// extracted by mini-css-extract-plugin
module.exports = {"label":"EngineCompartmentApiKeyPage_label__1vOVF","disableTextColor":"EngineCompartmentApiKeyPage_disableTextColor__1QlyK"};